<template>
    <div class="flex w-full"  style="padding-top: 1.5rem; padding-bottom: 1.5rem;justify-content: start; text-align: left;padding: 28px; background: #f5f7f9;">    
        <div v-if="isLoading" class="flex w-full items-center text-danger my-2 justify-center gap-1">
              <b-spinner class="align-middle"></b-spinner>
              <strong>Loading...</strong>
            </div>
        <div v-else style="width: 100%;"> 
            <ul v-if="activityLogs.length" id="comment-list">                
                    <div v-for="(log,index) in activityLogs" style="display: flex;" class="my-2" >
                        <div style="width: 3%; ">
                            <div class="outer-node mx-auto my-1">
                                <div class="node" />
                            </div>
                            <div v-if="index+1 < activityLogs.length" class="divider-grey mx-auto my-auto"/>
                            
                        </div>  
                        <div style="display: flex;width: 97%; padding-right: 4px;" >
                            
                            <li class="list" style="padding-bottom: 1rem;">
                                <div style="width: 20%;gap: 1rem;display: inline-flex;">                                    
                                    <div>
                                        <div><b>Ver {{ log.appVersion }}</b></div>

                                        <div v-if="log.approvalStatus ==='approved'"><span class="success-text">Approved on: </span><b>{{formatTime(log.createdAt) }}</b></div>                                       
                                        <div v-else-if="log.approvalStatus ==='disapproved'"><span class="danger-text">Disapproved on: </span><b>{{formatTime(log.createdAt) }}</b></div>
                                        <div v-else>Submitted: <b>{{formatTime(log.submittedOn ? log.submittedOn : '') }}</b></div>                                       
                                    </div>
                                </div>
                                <div style="width: 70%;gap: 1rem;" class="full-width">                                    
                                    <div class="border-box">
                                        <div><b>Comments:</b></div>
                                        <div v-if="!log.comment"><i>No comments</i></div>
                                        <div v-else-if="log.comment.length < 400">{{ log.comment }}</div>
                                        <div v-else><div :id="'comment-'+index">{{log.comment.slice(0, 400) + '...' }}</div> <span :id="'read-toggle-'+index" style="color: #155EEF;" @click="toggle(index)">See more</span></div>
                                        <div><b>By: </b> {{ log.approvedBy }}</div>
                                    </div>
                                </div>
                                <div style="width: 10%;gap: 1rem;" class="full-width">                                    
                                    <div class="border-box">
                                        <div><b>Listing Type:</b></div>
                                        <div><i>{{ log.isWhiteLabelFriendly === false ? 'Standard': 'White-label'}}</i></div>
                                    </div>
                                </div>
                            </li>
                        </div>
                    </div>
                    <div v-if="activityLogs.length<count"> <button id="load-more" class="btn btn-primary" @click="loadMore()" size="sm">View more</button></div>    
            </ul>
            <div v-else>
                <div style="display: flex;" class="my-2">
                        <div style="width: 3%; ">
                            <div class="outer-node mx-auto my-1">
                                <div class="node" />
                            </div>                            
                        </div>  
                        <div style="display: flex;width: 97%; padding-right: 4px;" >
                            
                            <li class="list" style="padding-bottom: 1rem;">
                                <div style="width: 20%;gap: 1rem;display: inline-flex;">
                                    
                                    <div>
                                        <div><b>Ver 1.0</b></div>
                                        <div v-if="app && app.submittedOn!=undefined">Submitted: <b>{{formatTime(app.submittedOn ? app.submittedOn:"") }}</b></div>
                                    </div>
                                </div>
                                <div style="width: 80%;gap: 1rem;" class="full-width">
                                    <div class="border-box">
                                        <div><b>Comments:</b></div>
                                        <div><i>No comments</i> </div>
                                    </div>
                                </div>
                            </li>
                        </div>
                    </div>
            </div>
        </div>
    </div>
</template>
  
<script>
import * as moment from "moment";
import { MarketplaceService } from "@/services"
import {ItemType} from "@/constants/Oauth.ts"

export default {
    data(){
        return {
            showAllText: false,
            activityLogs:[],
            limit: 10,
            skip: 0,
            count: 0,
            isLoading:false,
            app:undefined           
        }
    },
    props:{
      appId:String,
      itemId:String,
      itemType:ItemType
    },
    async created() {
        this.appId = this.$route.params.id || this.appId
        this.app = this.$store.getters['oauth_client_app/getApp']
        await this.fetchData();
    },
    methods: {
      async fetchData() {
        try {
          this.isLoading = true;   
          const query = {
            limit: this.limit,
            skip: this.skip
          }
          let response 
          if(this.itemId){
            query['itemId'] = this.itemId
            query['itemType'] = this.itemType
            response = await MarketplaceService.Review.getScriptActivityLogs(query)
          }else{
            response = await MarketplaceService.Review.getActivityLogs(this.appId, query)
          }
          if(response.data.comments){
            this.activityLogs = this.activityLogs.length===0 ? response.data.comments : [...this.activityLogs, ...response.data.comments]
            this.count = response.data.count
          }        
        } catch(error){
          console.error(error);
          alert(error.message || error.message[0] || "Something went wrong");
        }finally{
            this.isLoading = false
        }
      },     
      formatTime(time){
        return time ? moment(time).format(
          "MMM DD, YYYY"
        ): ""
      },
      toggle(id){
        this.showAllText = !this.showAllText
        const logComment = this.activityLogs[id].comment
        let btnText = document.getElementById(`read-toggle-${id}`);
        let commentText = document.getElementById(`comment-${id}`);
        commentText.innerHTML = this.showAllText ? logComment : logComment.slice(0, 400) + '...'
        btnText.innerHTML = this.showAllText ? "See less": "See more"
      },
      async loadMore(){
        this.skip = this.skip + this.limit
        await this.fetchData()
      }
      
    }
  };
</script>
<style scoped>
#more {display: none;}
.node {
    height: 10px;
    width: 10px;
    background-color: #155EEF;
    border-radius: 50%;
    display:flex;
    transition: all 1000ms ease;
    justify-content: center;
    align-items: center;
}
.outer-node{
    border:#d6e1fa;
    border-style: solid;
    border-radius: 50%;
    height: 30px;
    width: 30px;
    border-width: 4px;
    display: flex;
    justify-content: center;
    align-items: center;
}
.list{
    display: flex;
    width: 100%; 
    gap: 1rem
}
.full-width{
    display: flex;
    width: 100%;
    align-items: center;
}
.divider {
    min-height: 40px;
    width: 2px;
    margin-left: 4px;
    transition: all 800ms ease;
}
.border-box{
    padding-left: 1rem;
    border-left: 1px solid #a1a5ac;
}
.divider-grey {
    height: 80%;
    width: 3px;
    background-color: #155EEF;
   
}
.heading-font{
    font-style: normal;
    font-weight: 500;
    font-size: 20px;
    color: #374151;    
}
.subtitle-font{
    font-style: normal;
    font-weight: 400;
    font-size: 15px;
    line-height: 18px;
    color: #6B7280; 
}
.toCapitalFirst {
    text-transform: capitalize;
}
  
.tag{    
    border-radius: 13px;
    color: white;
    text-align: center;
    padding-left: 0.5rem;
    padding-right: 0.5rem; 
  }
  .info {
    color:#344054;
    background: #F2F4F7;
    mix-blend-mode: multiply;
  }
  .success {
    background: #12B76A;
  }
  .danger {
    background: #D92D20;
  }
  .danger-text {
    color: #D92D20;
  }
  .success-text {
    color: #12B76A;
  }
  .danger-btn {
    background: #FEF3F2;
    color: #B42318;
  }
  .warning {
    background: #F79009;
  }
  .truncate{
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap; 
}

</style>
